@if (story$ | async; as story) {
	@if (story.content) {
		<ndc-dynamic
			[ndcDynamicComponent]="components[story.content.component]"
			[ndcDynamicInputs]="story.content"
		>
		</ndc-dynamic>
	}
}
